"use client"

import { Image } from "@/app/components/image"
import { useLingui } from "@lingui/react/macro"
import { cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  imageSrc?: string
  collectionName: string
  className?: string
}

export function CollectionImage({
  imageSrc,
  collectionName,
  className,
}: Props) {
  const { t } = useLingui()

  return (
    <div className={cn("relative h-8 w-8", className)}>
      <Image
        className={cn("rounded-md border")}
        imageSrc={imageSrc}
        alt={t`Collection image for ${collectionName}`}
      />
    </div>
  )
}
